import styled from "styled-components";

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1100;
`;

export const PopupContainer = styled.div`
  position: relative;
  max-width: 440px;
  width: 90%;
  border-radius: 8px;
  overflow: hidden;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 32px;
  border-bottom: 1px solid #e5e7eb;
`;

export const Title = styled.h2`
  font-size: 1.25rem;
  font-weight: 700;
  color: #000;
  margin: 0;
  font-family: Pretendard, sans-serif;
`;

export const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: #000;
  cursor: pointer;
  transition: background-color 0.15s;

  &:hover {
    background-color: #f3f4f6;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 32px;
`;

export const ShieldImage = styled.img`
  width: 120px;
  height: 120px;
  object-fit: contain;
  margin-bottom: 16px;
`;

export const GuideText = styled.p`
  font-size: 15px;
  line-height: 1.6;
  text-align: center;
  color: #333;
  margin: 0 0 16px;
  font-family: Pretendard, sans-serif;

`;

export const FaqButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 100%;
  height: 48px;
  border-radius: 8px;
  background-color: #2563eb;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  font-family: Pretendard, sans-serif;
  text-decoration: none;
  cursor: pointer;
  border: none;
  transition: opacity 0.15s;

  &:hover {
    opacity: 0.9;
  }
`;

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 16px 32px;
  border-top: 1px solid #e5e7eb;
`;

export const OutlineButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  border-radius: 6px;
  background-color: #fff;
  color: #374151;
  font-size: 14px;
  font-weight: 500;
  font-family: Pretendard, sans-serif;
  cursor: pointer;
  border: 1px solid #d1d5db;
  transition: background-color 0.15s;

  &:hover {
    background-color: #f3f4f6;
  }
`;
